import {LOCATION_CHANGE} from 'connected-react-router';

export const LANDING_FORM_SENDING_DATA = 'LANDING_FORM_SENDING_DATA';
export const LANDING_FORM_DATA_SENT = 'LANDING_FORM_DATA_SENT';
export const LANDING_FORM_SEND_FAILED = 'LANDING_FORM_DATA_FAILED';
export const LANDING_FORM_CODE_MAILEXISTS = 'LANDING_FORM_CODE_MAILEXISTS';

const initialState = {
  data: null,
  error: false,
  submitting: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LANDING_FORM_SENDING_DATA: {
      return {
        ...state,
        data: null,
        error: false,
        submitting: true,
      };
    }

    case LANDING_FORM_CODE_MAILEXISTS: {
      return {
        data: action.responseCode,
        error: true,
        submitting: false,
      };
    }

    case LANDING_FORM_DATA_SENT: {
      return {
        data: action.responseCode,
        error: false,
        submitting: false,
      };
    }

    case LANDING_FORM_SEND_FAILED: {
      return {
        data: action.responseCode,
        error: false,
        submitting: false,
      };
    }

    case LOCATION_CHANGE: {
      return 'key' in action.payload.location ? {...state, data: null, error: null, submitting: false} : state;
    }

    default:
      return state;
  }
};
